export const enum LanguageEnum {
    EN = "en",
    HR = "hr",
    SI = "si"
}
